/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateUserFlowMutationInput = {
    clientMutationId?: string | null | undefined;
    flowKey: string;
    newState: string;
};
export type UpdateFlowStateUserMutationVariables = {
    input: UpdateUserFlowMutationInput;
};
export type UpdateFlowStateUserMutationResponse = {
    readonly updateFlowStateUser: {
        readonly flowState: {
            readonly id: string;
            readonly flowKey: string | null;
            readonly current: {
                readonly id: string;
                readonly state: string | null;
                readonly percentComplete: number | null;
                readonly errorMessage: string | null;
            } | null;
            readonly pending: {
                readonly id: string;
                readonly state: string | null;
                readonly percentComplete: number | null;
                readonly errorMessage: string | null;
            } | null;
        } | null;
    } | null;
};
export type UpdateFlowStateUserMutation = {
    readonly response: UpdateFlowStateUserMutationResponse;
    readonly variables: UpdateFlowStateUserMutationVariables;
};



/*
mutation UpdateFlowStateUserMutation(
  $input: UpdateUserFlowMutationInput!
) {
  updateFlowStateUser(input: $input) {
    flowState {
      id
      flowKey
      current {
        id
        state
        percentComplete
        errorMessage
      }
      pending {
        id
        state
        percentComplete
        errorMessage
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpdateUserFlowMutationPayload",
            "kind": "LinkedField",
            "name": "updateFlowStateUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlowState",
                    "kind": "LinkedField",
                    "name": "flowState",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flowKey",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlowStatus",
                            "kind": "LinkedField",
                            "name": "current",
                            "plural": false,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlowStatus",
                            "kind": "LinkedField",
                            "name": "pending",
                            "plural": false,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateFlowStateUserMutation",
            "selections": (v3 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateFlowStateUserMutation",
            "selections": (v3 /*: any*/)
        },
        "params": {
            "cacheID": "446de3a6bbb94b7681d39accc8844b1e",
            "id": null,
            "metadata": {},
            "name": "UpdateFlowStateUserMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateFlowStateUserMutation(\n  $input: UpdateUserFlowMutationInput!\n) {\n  updateFlowStateUser(input: $input) {\n    flowState {\n      id\n      flowKey\n      current {\n        id\n        state\n        percentComplete\n        errorMessage\n      }\n      pending {\n        id\n        state\n        percentComplete\n        errorMessage\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '411d6a596c3db4152adecb8aa740ef94';
export default node;
